(function () {
  // Exit early if running server-side or if IntersectionObserver not supported
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

  document.addEventListener('DOMContentLoaded', function () {
    // Main product grid inside collection section
    var grid = document.querySelector(
      '[data-section-id] .collection-listing .product-grid'
    );
    if (!grid) return;

    // Container that holds the pagination controls
    var paginationContainer = document.querySelector('.pagination-row');
    if (!paginationContainer) return;

    // Hide pagination from customer view but keep in DOM for intersection detection
    paginationContainer.style.visibility = 'hidden';
    paginationContainer.style.pointerEvents = 'none';

    var nextLink = paginationContainer.querySelector('a[rel="next"], .pagination__next');
    if (!nextLink) return;

    var isLoading = false;

    // Use IntersectionObserver to detect when the pagination row scrolls into view
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !isLoading) {
            loadMore();
          }
        });
      },
      {
        rootMargin: '200px 0px',
      }
    );

    observer.observe(paginationContainer);

    function loadMore() {
      if (!nextLink || isLoading) return;
      isLoading = true;

      fetch(nextLink.href, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          

          // Extract the new product cards - improved extraction
          var newGrid = tempDiv.querySelector('.collection-listing .product-grid');
          if (newGrid && newGrid.children.length > 0) {
            // Convert NodeList to Array and append each product
            var newProducts = Array.prototype.slice.call(newGrid.children);
            newProducts.forEach(function (item) {
              if (item && item.nodeType === 1) { // Ensure it's an element node
                grid.appendChild(item.cloneNode(true));
              }
            });
          } else {
            // Fallback: try to find products with more specific selectors
            var productItems = tempDiv.querySelectorAll('.product-grid > *');
            if (productItems.length > 0) {
              Array.prototype.forEach.call(productItems, function (item) {
                if (item && item.nodeType === 1) {
                  grid.appendChild(item.cloneNode(true));
                }
              });
            }
          }

          // Update next link for subsequent pages
          var newNextLink = tempDiv.querySelector('a[rel="next"], .pagination__next');
          if (newNextLink) {
            nextLink.href = newNextLink.href;
          } else {
            // No more pages to load; stop observing and remove pagination controls
            observer.disconnect();
            paginationContainer.parentNode && paginationContainer.parentNode.removeChild(paginationContainer);
            nextLink = null;
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.error('Infinite scroll: load failed', err);
        })
        .finally(function () {
          isLoading = false;
        });
    }
  });
})(); 